"use client";

import { ImageShowcase } from "@/app/(marketing)/components/demo/showcases/ImageShowcase";
import { StarPoint } from "@/app/(marketing)/components/demo/showcases/StarPoint";
import { ButtonLink } from "@/components/buttons/ButtonLink";
import screenshot from "@/public/images/appScreenshots/mix-voices.png";

export function MixShowcase() {
  return (
    <ImageShowcase
      screenshot={screenshot}
      headingText="Mix voices"
      altText="Screenshot of mix voices page"
    >
      <ul className="flex flex-col gap-y-2">
        <StarPoint>Mix your own unique voices</StarPoint>
        <StarPoint>
          Base them on Audimee&apos;s royalty-free voices and your own trained
          voices
        </StarPoint>
      </ul>
      <ButtonLink
        external={false}
        href="/mixed-voices"
        className="mt-6 block w-fit"
      >
        Explore
      </ButtonLink>
    </ImageShowcase>
  );
}
